import uniqBy from 'lodash/uniqBy'

import { useContext } from 'react'
import { CHANNEL_TYPES, DRAFTS_KEY, MESSAGE_TYPES } from '@/context/constants'
import { IDraft, StoreContextType } from '@/context/types'
import Loading from './Loading'

const Input = (context: React.Context<StoreContextType | null>) => {
  const store = useContext(context) as StoreContextType
  const { setLoading } = Loading(context)
  const userObj = store.name.userObj

  const getDrafts = () => {
    const draftMessages = (JSON.parse(
      localStorage.getItem(DRAFTS_KEY) as string,
    ) || []) as IDraft[]

    return draftMessages
  }

  const setDrafts = (draftMessages: IDraft[]) => {
    localStorage.setItem(DRAFTS_KEY, JSON.stringify(draftMessages))
  }

  const getInputMessage = (conversationId?: string) => {
    const draftMessages = getDrafts()
    const targetDraft = draftMessages.find(
      draft => draft.conversationId === conversationId,
    )
    return targetDraft?.message || ''
  }

  const setInputMessage = (message: string) => {
    const conversationId = store.selectConversation.selectedConversation

    const draftMessages = getDrafts()

    const targetDraft = draftMessages.find(
      draft => draft.conversationId === conversationId,
    )

    if (targetDraft) {
      targetDraft.message = message
    } else {
      draftMessages.push({
        conversationId: conversationId,
        message,
      })
    }
    setDrafts(draftMessages)
    store.force.setForceUpdate(prev => !prev)

    store.inputMessage.setMessage(message)
    return
  }

  const sendMessage = (payload: any) => {
    const wsInstance = store.websocket.instance

    if (wsInstance?.readyState === wsInstance?.OPEN) {
      setLoading({
        conversations: payload.type === MESSAGE_TYPES.GET_CONVERSATIONS,
        messages: payload.type === MESSAGE_TYPES.GET_MESSAGES,
        faq: payload.type === MESSAGE_TYPES.GET_FAQ,
      })

      wsInstance?.send(
        JSON.stringify({
          ...payload,
          metadata: {
            ...payload.metadata,
            channel: CHANNEL_TYPES.CHAT,
            to: uniqBy(
              [
                ...(payload?.metadata?.to || []),
                {
                  userExternalId: store.config.objConfig?.userExternalId,
                  type: store.config.objConfig?.userType,
                  firstName: userObj?.firstName,
                  lastName: userObj?.lastName,
                },
              ],
              item => item.userExternalId,
            ),
          },
        }),
      )
    }
  }

  const getSendTo = () => store.sendTo.sendToReceipients
  const setSendTo = (values: any) =>
    store.sendTo.setSendToReceipients(prev => ({ ...prev, ...values }))

  return {
    getDrafts,
    setDrafts,
    getInputMessage,
    setInputMessage,
    sendMessage,
    getSendTo,
    setSendTo,
  }
}

export default Input
